import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, confirm, findAncestor, handleSwitchInputKeys } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from 'react-launch-darkly';
import ReactQuill from 'react-quill';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';

// Components
import * as icons from '../Icons/Icons';

const ProctorGroups = observer(class ProctorGroups extends React.Component {
  constructor() {
    super();
    this.addGroup = this.addGroup.bind(this);
    this.sortGroups = this.sortGroups.bind(this);
    this.editGroups = this.editGroups.bind(this);
    this.removeGroup = this.removeGroup.bind(this);
    this.selectProctorType = this.selectProctorType.bind(this);
    this.disableProctorType = this.disableProctorType.bind(this);
    this.checkProctorTypes = this.checkProctorTypes.bind(this);
    this.setLocations = this.setLocations.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.searchProctorLocations = this.searchProctorLocations.bind(this);
    this.resetProctorLocations = this.resetProctorLocations.bind(this);
    this.addProctorLocation = this.addProctorLocation.bind(this);
    this.removeProctorLocation = this.removeProctorLocation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
    this.updateIcon = this.updateIcon.bind(this);
    this.expandInvalid = this.expandInvalid.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.renderDisabled = this.renderDisabled.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.state = {
      groups: []
    }

    // Get enabled proctor types
    SessionStore.getFilteredProctorTypes();

    // Get existing proctor groups
    this.getProctorGroups();
  }

  getProctorGroups() {
    this.props.store.ProctorStore.getProctorGroups(this);
  }

  addGroup() {
    let groups = [...this.state.groups];
    const newGroup = {
      title: '',
      description: '',
      buttonText: '',
      icon: '',
      includeOnlyApproved: false,
      proctorTypes: [],
      proctorLocationSids: [],
      proctorLocationDetails: [],
      sid: (new Date()).getTime()
    }

    groups.push(newGroup);

    this.setState({
      groups
    });
  }

  sortGroups = ({oldIndex, newIndex}) => {
    this.setState({
      groups: arrayMove(this.state.groups, oldIndex, newIndex),
    });
  };

  editGroups(text, i, key, boolean) {
    let groups = [...this.state.groups];
    groups[i][key] = text;

    // If it’s a boolean value
    if(typeof boolean !== 'undefined') {
      groups[i][key] = boolean;
    }

		this.setState({
      groups
    });

    this.forceUpdate();
  }

  removeGroup(i) {
    let groups = [...this.state.groups];

    groups.splice(i, 1);

    this.setState({
      groups
    })
  }

  toggleTypes(i) {
    if(typeof i !== 'undefined') {
      const group = document.querySelectorAll('.proctor-group')[i];
      group.classList.toggle('open');

      const types = group.nextSibling;
      types.classList.toggle('open');
    } else {
      const groups = document.querySelectorAll('.proctor-group');

      for(let i = 0; i < groups.length; i++) {
        groups[i].classList.remove('open');

        const types = groups[i].nextSibling;
        types.classList.remove('open');
      }
    }
  }


  selectProctorType(e, i, exclusive, requireLocation) {
    const { SessionStore } = this.props.store;
    let groups = [...this.state.groups];

    if(e.target.checked) {
      if(exclusive) {
        // If this is an exclusive type, make sure there are no others selected
        groups[i].proctorTypes.length = 0;
      }

      groups[i].proctorTypes.push(e.target.value);
    } else {
      const index = groups[i].proctorTypes.indexOf(e.target.value);
      groups[i].proctorTypes.splice(index, 1);
      groups[i].proctorLocationSid = '';
    }

    // If this is an exclusive proctor type, disable others on check
    // and enable others on uncheck
    if(exclusive) {
      let thisGroup = document.querySelectorAll('.block-list .slideout')[i];
      let thisSwitches = thisGroup.querySelectorAll('input.switch-input:not(:checked)');

      if(e.target.checked) {
        const dialogContent = this.props.translation.exclusive;
        SessionStore.showDialog(dialogContent);

        for(let i = 0; i < thisSwitches.length; i++) {
          thisSwitches[i].disabled = true;
        }
      } else {
        for(let i = 0; i < thisSwitches.length; i++) {
          thisSwitches[i].disabled = false;
        }
      }

    // Otherwise disable exclusive types when non-exclusives are selected
    } else {
      let thisGroup = document.querySelectorAll('.block-list .slideout')[i];
      let thisExclusives = thisGroup.querySelectorAll('input.switch-input.exclusive');

      if(e.target.checked) {
        for(let i = 0; i < thisExclusives.length; i++) {
          thisExclusives[i].disabled = true;
        }
      } else {
        for(let i = 0; i < thisExclusives.length; i++) {
          thisExclusives[i].disabled = false;
        }
      }
    }

    // If a location is required, clear out the current locations array and get a new one
    // from the API
    if(requireLocation) {
      groups[i].locations = [];

      const query = `?proctorSubcategories=${e.target.value}`
      this.props.store.ProctorStore.searchProctors(query, this.setLocations, i);
    }

    // If the proctor group has locations set,
    // get the details for those locations from the API
    if(groups[i].proctorLocationSids && groups[i].proctorLocationSids.length > 0) {
      groups[i].proctorLocationDetails = {};

      let query = '?';

      // Get all the location sids for the query
      for(let li = 0; li < groups[i].proctorLocationSids.length; li++) {
        if(li > 0) {
          query += '&';
        }

        query += `proctorLocationSids=${groups[i].proctorLocationSids[li]}`;
      }

      // Callback function that adds the data to the group’s state
      const callback = (i, results) => {
        results.forEach(result => {
          groups[i].proctorLocationDetails[result.location.sid] = result;
        })
      }

      // Make the API call
      this.props.store.ProctorStore.searchProctors(query, callback, i);
    }

    this.setState({
      groups
    });
  }

  searchProctors(sid, i) {
    const _this = this;
    let groups = [...this.state.groups];

    setTimeout(function(){
      if(typeof groups[i].locations === 'undefined' && !groups[i].gotLocations) {
        groups[i].gotLocations = true;
        const query = `?proctorSubcategories=${sid}`
        _this.props.store.ProctorStore.searchProctors(query, _this.setLocations, i);
      }
    })
  }

  setLocations(i, locations) {
    let groups = [...this.state.groups];

    groups[i].locations = locations;

    this.setState({
      groups
    });
  }

  selectLocation(e, i) {
    let groups = [...this.state.groups];

    groups[i].proctorLocationSid = e.target.value;

    this.setState({
      groups
    });
  }

  // Disable proctor type selection if an exclusive one is already selected
  disableProctorType(i, typeKey) {
    const { proctorTypeList } = this.props.store.SessionStore;
    let disable = false;
    let exclusiveProctorTypes = [];

    // First loop through the allowable proctor types and make an array exclusive subcategories
    proctorTypeList.forEach(function(type){
      if(type.subCategories.length > 0) {
        type.subCategories.forEach(function(subType){
          if(subType.mutuallyExclusiveInProctorGroup) {
            exclusiveProctorTypes.push(subType.sid);
          }
        })
      }
    });

    // Get the selected types
    const selectedProctorTypes = this.state.groups[i].proctorTypes;

    // Then loop through them and check if they are exclusive
    selectedProctorTypes.forEach(function(type){
      if(exclusiveProctorTypes.indexOf(type) > -1) {
        disable = true;
      }
    });

    // If this is the exclusive type, don’t disable it
    if(exclusiveProctorTypes.indexOf(typeKey) > -1 && selectedProctorTypes.indexOf(typeKey) > -1) {
      disable = false;
    }

    return disable;
  }

  checkProctorTypes() {
    const { proctorTypeList } = this.props.store.SessionStore;

    // Check if all allowable proctor types are assigned
    let allProctorTypes = [];
    let selectedProctorTypes = [];
    let unselectedProctorTypes = [];

    // First loop through the allowable proctor types and make an array of the subcategories
    proctorTypeList.forEach(function(type){
      if(type.subCategories.length > 0) {
        type.subCategories.forEach(function(subType){
          if(subType.status !== 'disabled') {
            allProctorTypes.push(subType);
          }
        })
      }
    });

    // Then loop through all of the selected proctor types and make an array
    this.state.groups.forEach(function(group){
      if(group.proctorTypes.length > 0) {
        group.proctorTypes.forEach(function(subType){
          if(subType) {
            selectedProctorTypes.push(subType)
          }
        });
      }
    });

    // Then loop through all of the proctor types and check if they are selected
    allProctorTypes.forEach(function(type){
      selectedProctorTypes.indexOf(type.sid)

      if(selectedProctorTypes.indexOf(type.sid) < 0) {
        unselectedProctorTypes.push(type);
      }
    })

    if(unselectedProctorTypes.length > 0) {
      let unselectedList = '';

      unselectedProctorTypes.forEach(function(type){
        unselectedList += `<li>${type.title}</li>`
      })

      let message = this.props.translation.not_selected;
      message.data = unselectedList;

      confirm(message, this.handleSubmit)
    } else {
      this.handleSubmit();
    }
  }

  expandInvalid() {
    const invalidSelects = document.querySelectorAll('.submitted select:invalid');

    for(let i = 0; i < invalidSelects.length; i++) {
      const parent = findAncestor(invalidSelects[i], 'slideout');

      if(!parent.classList.contains('open')) {
        parent.className += ' open';
      }
    }
  }

  getElement(parent, cls) {
    let el = null;
    const elements = parent.childNodes;

    for(let e = 0; e < elements.length; e++) {
      if(elements[e].className.indexOf(cls) >= 0)  {
        el = elements[e];
      }
    }

    return el;
  }

  toggleLocations(i) {
    if(typeof i !== 'undefined') {
      const group = document.querySelectorAll('.proctor-group')[i];
      group.classList.toggle('open');

      const locationsEl = this.getElement(group.parentNode, 'group-locations');

      if(locationsEl) {
        locationsEl.classList.toggle('open');
      }
    } else {
      const groups = document.querySelectorAll('.proctor-group');

      for(let i = 0; i < groups.length; i++) {
        groups[i].classList.remove('open');

        const locationsEl = this.getElement(groups[i].parentNode, 'group-locations');

        if(locationsEl) {
          locationsEl.classList.remove('open');
        }
      }
    }

    // If the location details are not already present, get them
    if(!this.state.groups[i].proctorLocationDetails && this.state.groups[i].proctorLocationSids.length > 0) {
      this.props.store.ProctorStore.getLocationDetails(this.state.groups[i].proctorLocationSids, i, this);
    }
  }

  searchProctorLocations(e, i) {
    const keyword = e.target.value;
    const query = `?keyword=*${keyword}*&limit=100`;
    let groups = [...this.state.groups];

    const callback = (i, results) => {
      groups[i].proctorLocations = results;

      this.setState({
        groups
      });
    }

    if(keyword) {
      this.props.store.ProctorStore.searchProctors(query, callback, i, true);
    } else {
      groups[i].proctorLocations = [];

      this.setState({
        groups
      });
    }
  }

  resetProctorLocations(i) {
    let groups = [...this.state.groups];

    // Reset the text field
    this[`location${i}`].value = '';

    // Remove the search results
    groups[i].proctorLocations = [];

    // Update the state
    this.setState({
      groups
    });
  }

  addProctorLocation(i, location) {
    const locationSid = location.location.sid;
    let groups = [...this.state.groups];

    // Add the sid
    if(groups[i].proctorLocationSids) {
      groups[i].proctorLocationSids.push(location.location.sid);
    } else {
      groups[i].proctorLocationSids = [location.location.sid];
    }

    // Add the details
    if(!groups[i].proctorLocationDetails) {
      groups[i].proctorLocationDetails = {};
    }

    groups[i].proctorLocationDetails[locationSid] = location;

    // Update the state
    this.setState({
      groups
    });

    // Reset the location form
    // this.resetProctorLocations(i);
  }

  removeProctorLocation(i, locationSid) {
    let groups = [...this.state.groups];
    let index = 0;

    // Loop through this group’s location sids
    // to get the index of the one we’re removing
    groups[i].proctorLocationSids.forEach((sid, thisIndex) => {
      if(sid === locationSid) {
        index = thisIndex;
      }
    });

    // Remove the selected sid
    groups[i].proctorLocationSids.splice(index, 1);

    // Update the state
    this.setState({
      groups
    });
  }

  handleSubmit() {
    const { translation } = this.props;

    this.toggleTypes();

    let data = []

    for(let i = 0; i < this.state.groups.length; i++) {
      const obj = {
        buttonText: this.state.groups[i].buttonText,
        description: this.state.groups[i].description,
        icon: this.state.groups[i].icon,
        includeOnlyApproved: this.state.groups[i].includeOnlyApproved,
        proctorLocationSid: this.state.groups[i].proctorLocationSid,
        proctorLocationSids: this.state.groups[i].proctorLocationSids,
        proctorTypes: this.state.groups[i].proctorTypes,
        sid: this.state.groups[i].sid,
        title: this.state.groups[i].title,
        workflowModule: this.state.groups[i].workflowModule,
        alwaysShow: this.state.groups[i].alwaysShow
      }

      data.push(obj);
    }

    data.forEach(function(group) {
      if(!group.buttonText) {
        group.buttonText = translation.default_button_text;
      }

      // Remove temporary sid
      if(typeof group.sid !== 'string') {
        delete group.sid;
      }
    });

    this.props.store.ProctorStore.updateProctorGroups(data, this.complete);
  }

  complete() {
    this.props.store.SessionStore.showToaster(this.props.translation.groups_saved, 'success');
  }

  renderIcon(icon) {
    switch (icon) {
      case 'person':
        return <icons.iconIndividual />

      case 'attended':
        return <icons.iconAttended />

      case 'unattended':
        return <icons.iconUnattended />

      case 'instructor':
        return <icons.iconInstructor />

      case 'testing_centers':
        return <icons.iconTestingCenters />

      case 'testing_centers_individuals':
        return <icons.iconCentersIndivuals />

      case 'examity':
        return <icons.iconExamity />

      case 'proctoru':
        return <icons.iconProctorU />

      default:
        return ''
    }
  }

  updateIcon(e, i) {
    const icon = this[`icon${i}`].value;
    let groups = [...this.state.groups];

    groups[i].icon = icon;

    this.setState({
      groups
    });
  }

  DragHandle = SortableHandle(() => {
    const { translation } = this.props;

    return (
      <span className="draggable__handle">
        <span className="draggable__handle__tooltip">{translation.reorder}</span>
      </span>
    )
  });

  SortableItem = SortableElement((props) => {
    const { i, value, onInputChange } = props;
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    function subCategoryLength(subCategories) {
      let enabledSubcategories = subCategories.filter(function(subCategory){
        return subCategory.status !== 'disabled';
      });

      if (enabledSubcategories.length > 0) {
        return true;
      }

      return false;
    }

    // Quill text editor toolbar options
    const modules = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'bullet'}, {'list': 'ordered'}]
      ]
    };

    return (
      <li className="draggable-element">
        <div className="block-list__block media--alt proctor-group draggable">
          <ul className="fields proctor-group__icon">
            <li>
              <label className="lbl-required" htmlFor={`group${i}-icon`}>{translation.icon.label}</label>

              <label className="select">
                <select
                  id={`group${i}-icon`}
                  value={value.icon}
                  onChange={(e) => {this.updateIcon(e, i)}}
                  ref={(input) => {this[`icon${i}`] = input}}
                  required
                  aria-required="true"
                >
                  <option value="">{translation.icon.helper}</option>
                  <option value="person">{translation.icon.options.person}</option>
                  <option value="instructor">{translation.icon.options.instructor}</option>
                  <option value="attended">{translation.icon.options.attended_virtual}</option>
                  <option value="unattended">{translation.icon.options.unattended_virtual}</option>
                  <option value="testing_centers">{translation.icon.options.building}</option>
                  <option value="testing_centers_individuals">{translation.icon.options.building_person}</option>
                  <option value="examity">{translation.icon.options.examity}</option>
                  <option value="proctoru">{translation.icon.options.proctoru}</option>
                </select>
              </label>
            </li>
            <li>
              {this.renderIcon(value.icon)}
            </li>
            <li>
              <label
                className="lbl-required"
                htmlFor={`group${i}-workflow`}
              >
                {translation.workflow.label}
              </label>

              <label className="select">
                <select
                  id={`group${i}-workflow`}
                  value={value.workflowModule}
                  onChange={e => onInputChange(e.target.value, i, 'workflowModule')}
                >
                  <option value="">{translation.workflow.helper}</option>
                  {Object.keys(translation.workflow.options).map(key =>
                    <option value={key}>{translation.workflow.options[key]}</option>
                  )}
                </select>
              </label>
            </li>
          </ul>

          <div className="media__copy">
            <ul className="fields">
              <li>
                <label className="lbl-required" htmlFor={`group${i}-title`}>{translation.title}</label>
                <input
                  id={`group${i}-title`}
                  type="text"
                  value={value.title}
                  ref={(input) => {this[`title${i}`] = input}}
                  onChange={(e) => onInputChange(e.target.value, i, 'title')}
                  required
                  aria-required="true"
                />
              </li>
              <li key={value.sid}>
                <label className="lbl-required" htmlFor={`group${i}-description`}>
                  {translation.description}
                </label>

                <ReactQuill
                  modules={modules}
                  value={value.description}
                  onChange={(e) => onInputChange(e, i, 'description')}
                />
              </li>
              <li>
                <label className="lbl-required" htmlFor={`group${i}-button`}>{translation.button_text}</label>

                <input
                  id={`group${i}-button`}
                  type="text"
                  value={value.buttonText || translation.default_button_text}
                  ref={(input) => {this[`buttonText{i}`] = input}}
                  onChange={(e) => onInputChange(e.target.value, i, 'buttonText')}
                  required
                  aria-required="true"
                />
              </li>
              {value.workflowModule !== 'hybrid-tiered-scheduling' &&
              <li>
                <label htmlFor={`group${i}-approved`} aria-describedby="suggest-times-tooltip">
                  {translation.only_approved.label}

                  <div className="tooltip tooltip--right">
                    <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                    <div id="suggest-times-tooltip" className="tooltip__body"
                         role="tooltip">{translation.only_approved.tooltip}</div>
                  </div>
                </label>

                <input
                  type="checkbox"
                  id={`group${i}-approved`}
                  className="switch-input"
                  checked={value.includeOnlyApproved}
                  onKeyDown={handleSwitchInputKeys}
                  onChange={(e) => onInputChange(e.target.value, i, 'includeOnlyApproved', e.target.checked)}
                />


                <label className="switch-label" htmlFor={`group${i}-approved`}><span
                  className="meta">{translation.only_approved.label}</span></label>
              </li>
              }
              {value.workflowModule !== 'hybrid-tiered-scheduling' &&
              <li>
                <label htmlFor={`group${i}-always`} aria-describedby="always-show-tooltip">
                  {translation.always_show.label}

                  <div className="tooltip tooltip--right">
                    <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                    <div id="always-show-tooltip" className="tooltip__body"
                         role="tooltip">{translation.always_show.tooltip}</div>
                  </div>
                </label>

                <input
                  type="checkbox"
                  id={`group${i}-always`}
                  className="switch-input"
                  checked={value.alwaysShow}
                  onKeyDown={handleSwitchInputKeys}
                  onChange={(e) => onInputChange(e.target.value, i, 'alwaysShow', e.target.checked)}
                />


                <label className="switch-label" htmlFor={`group${i}-always`}><span
                  className="meta">{translation.always_show.label}</span></label>
              </li>
              }
              <li>
                <label className="lbl-optional">
                  {value.proctorTypes.length || 'No'}&nbsp;
                  {value.proctorTypes.length === 1 &&
                  <span>{translation.proctor_types.label.replace('types', 'type')}</span>
                  }

                  {value.proctorTypes.length !== 1 &&
                  <span>{translation.proctor_types.label}</span>
                  }
                </label>

                <button className="btn--link" type="button" onClick={() => {
                  this.toggleTypes(i)
                }}>{translation.proctor_types.edit}</button>
              </li>
              {value.workflowModule !== 'hybrid-tiered-scheduling' &&
                  <li>
                  <label className="lbl-optional">
                {value.proctorLocationSids &&
                  <span>
                {value.proctorLocationSids.length || 'No'}&nbsp;

                {value.proctorLocationSids.length === 1 &&
                  <span>{translation.proctor_locations.label.replace('locations', 'location')}</span>
                }

                {value.proctorLocationSids.length !== 1 &&
                  <span>{translation.proctor_locations.label}</span>
                }
                  </span>
                }

                {!value.proctorLocationSids &&
                  <span>No {translation.proctor_locations.label}</span>
                }
                  </label>

                  <button className="btn--link" type="button" onClick={() => {this.toggleLocations(i)}}>{translation.proctor_locations.edit}</button>
                  </li>
              }
            </ul>
          </div>

          <div className="media__tools proctor-group__tools">
            <button className="btn--delete proctor-group__delete" type="button" onClick={() => {this.removeGroup(i)}}>
              <icons.iconTrash />
              <span className="meta">{translation.delete_group}</span>
            </button>
          </div>

          <this.DragHandle />
        </div>

        {/* Proctor types panel */}
        <div className="slideout group-types">
          {SessionStore.proctorTypeList.map(
            (key, j) =>
            {
              if(subCategoryLength(key.subCategories)) {
                return (
                  <div className="form-subgroup" key={j}>
                    <strong className="form-subheading">{key.title}</strong>

                    <ul className="switch-list">
                      {key.subCategories.map(
                        (subKey, k) => {
                          if(subKey.status === 'disabled') {
                            return '';
                          } else {
                            return (
                              <li key={k}>
                                <label htmlFor={`${subKey.sid}-${i}`}>{subKey.title}</label>

                                <input
                                  type="checkbox"
                                  id={`${subKey.sid}-${i}`}
                                  className={`switch-input ${subKey.mutuallyExclusiveInProctorGroup ? 'exclusive' : 'inexclusive'}`}
                                  value={subKey.sid}
                                  onKeyDown={handleSwitchInputKeys}
                                  onChange={(e) => {this.selectProctorType(e, i, subKey.mutuallyExclusiveInProctorGroup, subKey.requireLocationInProctorGroup)}}
                                  checked={value.proctorTypes.indexOf(subKey.sid) > -1}
                                  disabled={this.disableProctorType(i, subKey.sid)}
                                  data-require={subKey.requireLocationInProctorGroup}
                                />

                                <label className="switch-label" htmlFor={`${subKey.sid}-${i}`}><span className="meta">{subKey.title}</span></label>

                                {subKey.requireLocationInProctorGroup &&
                                  <label className="select select--required switch-list__select" htmlFor={`${subKey.sid}-l-${i}`}>
                                    <select
                                      id={`${subKey.sid}-l-${i}`}
                                      value={value.proctorLocationSid || ''}
                                      onChange={(e) => {this.selectLocation(e, i)}}
                                      required={value.proctorTypes.indexOf(subKey.sid) > -1}
                                      aria-required="true"
                                    >
                                      <option value="">{translation.select_location}</option>
                                      {value.proctorTypes.indexOf(subKey.sid) > -1 &&
                                        this.searchProctors(subKey.sid, i)
                                      }
                                      {value.locations &&
                                        value.locations.map(
                                          (location, l) =>
                                          <option key={l} value={location.location.sid}>
                                            {location.proctor.accountName} - {location.location.name}
                                          </option>
                                        )
                                      }
                                    </select>
                                  </label>
                                }
                              </li>
                            )
                          }
                        }
                      )}
                    </ul>
                  </div>
                )
              }

              return '';
            }
          )}
        </div>

        {/* Proctor locations panel */}
        <div className="slideout slideout--alt group-locations">
          {value.proctorLocationSids &&
            <div className="tags">
              {value.proctorLocationSids.map(
                (sid) => {
                  if(
                    this.state.groups[i].proctorLocationDetails &&
                    this.state.groups[i].proctorLocationDetails[sid]
                  ) {
                    return (
                      <button
                        key={sid}
                        className="tag tag--removable tag--alt"
                        type="button"
                        onClick={() => this.removeProctorLocation(i, sid)}
                      >
                        {this.state.groups[i].proctorLocationDetails[sid].proctor.accountName} – {this.state.groups[i].proctorLocationDetails[sid].location.name}
                      </button>
                    )
                  }

                  return null;
                }
              )}
            </div>
          }

          <div className="suggestion-wrap">
            <input
              type="text"
              className="suggestion-inp"
              ref={(input) => {this[`location${i}`] = input}}
              placeholder={translation.proctor_locations.search_proctors}
              onChange={(e) => this.searchProctorLocations(e, i)}
            />

            {this[`location${i}`] && this[`location${i}`].value &&
              <button
                className="suggestion-cancel"
                type="button"
                onClick={(e) => this.resetProctorLocations(i)}
              >
                <span className="meta">{translation.cancel}</span>
              </button>
            }

            {this.state.groups[i].proctorLocations &&
              <ul className="suggestion-list">
                {this.state.groups[i].proctorLocations.map(
                  (key, j) => {
                    if(
                      this.state.groups[i].proctorLocationSids &&
                      this.state.groups[i].proctorLocationSids.indexOf(key.location.sid) < 0
                    ) {
                      return (
                        <li key={j}>
                          <button
                            className="suggestion btn--reset"
                            type="button"
                            onClick={() => this.addProctorLocation(i, key)}
                            disabled={
                              this.state.groups[i].proctorLocationSids &&
                              this.state.groups[i].proctorLocationSids.indexOf(key.location.sid) >= 0
                            }
                          >
                            {key.proctor.accountName}

                            {key.location.name &&
                              <span className="suggestion__subtitle">{key.location.name}</span>
                            }

                            {key.location.name &&
                              <span className="suggestion__subtitle">{key.location.address1}</span>
                            }

                            {key.location.schedulingModule === 'register-blast' &&
                              <img className="suggestion__icn" src="./static/img/icn-registerblast.png" height="20" alt="RegisterBlast" role="presentation" />
                            }
                          </button>
                        </li>
                      )
                    } else {
                      return null;
                    }
                  }
                )}
              </ul>
            }
          </div>
        </div>
      </li>
    )
  });

  SortableList = SortableContainer(({items, onInputChange}) =>{
    return (
      <ul className="block-list fields">
        {items.map(
          (key, i) =>
          <this.SortableItem key={i} index={i} value={key} i={i} onInputChange={onInputChange} />
        )}
      </ul>
    )
  });

  renderForm() {
    const { translation } = this.props;

    return (
      <form className="proctor-group-form" onSubmit={(e) => checkValidity(e, this.checkProctorTypes, 'form.proctor-group-form', this.expandInvalid)} noValidate>
        <this.SortableList
          items={this.state.groups}
          onSortEnd={this.sortGroups}
          axis="y"
          lockAxis="y"
          helperClass="dragging"
          useDragHandle={true}
          onInputChange={(text, i, key, boolean) => this.editGroups(text, i, key, boolean)}
          useWindowAsScrollContainer={true}
        />

        <button className="block-list__add" type="button" onClick={this.addGroup}>
          <icons.iconPlus />
          {translation.add_group}
        </button>

        <button className="btn btn--large" type="submit">{translation.button}</button>
      </form>
    )
  }

  renderDisabled() {
    const { translation } = this.props;

    return (
      <div className="panel panel--brief">
        <h2 className="panel__title">{translation.disabled.heading}</h2>

        <p>
          {translation.disabled.body}
          <a href="mailto:jason@smarterservices.com">
            {translation.disabled.contact}
          </a>.
        </p>
      </div>
    )
  }

  render() {
    // const { translation } = this.props;
    const { SessionStore } = this.props.store;

    if(!SessionStore.loading || this.state.groups.length > 0) {
      return (
        <div className="wrap wrap--brief">
          <FeatureFlag
            flagKey="disable-proctor-groups"
            renderFeatureCallback={this.renderDisabled}
            renderDefaultCallback={this.renderForm}
          />
        </div>
      )
    }

    return null;
  }
})

export default translate('ProctorGroups')(ProctorGroups);



// WEBPACK FOOTER //
// ./src/app/components/Settings/ProctorGroups.js